// extracted by mini-css-extract-plugin
module.exports = {"ad__item__wrapper":"styles_ad__item__wrapper__3mN68","ration-16-9":"styles_ration-16-9__1r2pU","head":"styles_head__4QSUl","footer":"styles_footer__1VoEW"};